import React from 'react'

const FooterBottom = () => {
  return (
    <div>
      
    </div>
  )
}

export default FooterBottom
